exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FileUpload_input_3n2i {\n  display: block;\n\n  width: 1px;\n  height: 1px;\n\n  opacity: 0;\n}\n", ""]);

// exports
exports.locals = {
	"input": "FileUpload_input_3n2i"
};